import { useRef } from 'react';

import useAnimate from '@Hotels-at-Home/hah-fe-core/dist/hooks/useAnimate';
import HeroSection from './sections/HeroSection';
import BedLinensSection from './sections/BedLinensSection';
import RobesSection from './sections/RobesSection';
import BathSpaSection from './sections/BathSpaSection';
import FragranceSection from './sections/FragranceSection';
import ExclusivesSection from './sections/ExclusivesSection';
import KidsSection from './sections/KidsSection';
import SeoSection from './sections/SeoSection';
import { IGetPromotionResponse } from '@Hotels-at-Home/hah-fe-core/dist/types';

interface IProps {
  promotion: IGetPromotionResponse;
}

const Home = ({ promotion }: IProps) => {
  const animateRef = useRef(null);
  useAnimate(animateRef);

  return (
    <div id="home" ref={animateRef}>
      <HeroSection promotion={promotion} />
      <BedLinensSection />
      <RobesSection />
      <BathSpaSection />
      <FragranceSection />
      <ExclusivesSection />
      <KidsSection />
      <SeoSection />
    </div>
  );
};

export default Home;
